module.exports = __webpack_public_path__ + "assets/img/panasonic.edea6fd2.png";